import React, { useCallback } from 'react';
import { block } from 'bem-cn';
import { useSelector } from 'react-redux';

import InputDate from 'components/InputDate/desktop';
import Button from 'components/Button/Button';
import CheckBox from 'components/CheckBox';
import useTree from 'hooks/useTree';
import SearchUserInput from 'components/SearchUserInput/SearchUserInput';

import './UsersFilterBlock.scss';

const b = block('users-filter-block-desktop');

const UsersFilterBlock = ({
  filterValue,
  date,
  onChangeBeginDate,
  onChangeEndDate,
  onResetFilter,
  callBack = null,
  actionProcessing,
  placeholder = null,
  isDirectStructure,
  onChangeDirectStructure,
  searchResult,
  handleResultClick,
  isLoadingSearchResult,
  handleSearchChange,
}) => {
  const locale = useSelector(state => state.locale.locale);
  const { getTreeById } = useTree();

  const activeCallback = () => {
    if (callBack) return callBack();
    return getTreeById(filterValue || '');
  };

  const onButtonClick = useCallback(
    props => {
      if (props) {
        switch (props.type) {
          case 'keydown':
            if (props?.event.key === 'Enter') activeCallback();
            break;
          default:
            return null;
        }
      }
    },
    [filterValue],
  );

  return (
    <form
      className={b()}
      onSubmit={e => {
        e.preventDefault();
        if (callBack) callBack();
      }}>
      <div className={b('item')}>
        <div className={b('title')}>{locale.player_agent}</div>
        <SearchUserInput
          {...{
            filterValue,
            onButtonClick,
            handleSearchChange,
            placeholder,
            locale,
            isLoadingSearchResult,
            searchResult,
            handleResultClick,
          }}
        />
        <div className={b('description')}>({locale.typeOnlyLowercase})</div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>{locale.dateFrom}</div>
        <div className={b('input')}>
          <InputDate selected={date.beginDate} onChange={onChangeBeginDate} />
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>{locale.dateTo}</div>
        <div className={b('input')}>
          <InputDate selected={date.endDate} onChange={onChangeEndDate} />
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>&nbsp;</div>
        <div className={b('checkbox')}>
          <CheckBox checked={isDirectStructure} onChange={() => onChangeDirectStructure(!isDirectStructure)} />
          <div>{locale.directOnly}</div>
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>&nbsp;</div>
        <div className={b('button')}>
          <Button text={locale.acceptFilter} /* callBack={callBack} */ disabled={actionProcessing} type="submit" />
        </div>
      </div>
      <div className={b('item')}>
        <div className={b('title')}>&nbsp;</div>
        <div className={b('button')}>
          <Button text={locale.resetFilter} color="transparent" callBack={onResetFilter} />
        </div>
      </div>
    </form>
  );
};

export default UsersFilterBlock;
